import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PrimeNgModule } from '@app/shared/primeng/primeng.module';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-toogle-switch',
  standalone: true,
  imports: [CommonModule, TranslateModule, PrimeNgModule],
/*
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => 'switchPrivacy1'),
      multi: true,
    }
  ],
   */
  templateUrl: './toogle-switch.component.html',
  styleUrl: './toogle-switch.component.scss'
})
export class ToogleSwitchComponent {

  @Input() switchState: 'y' | 'n' | '' = '';
  @Output() onChange = new EventEmitter<boolean | null>();

  propagateChange = (_: any) => {};

  constructor(
    ) {}

  ngOnInit(): void {

  }

  onclickYes() {
      this.switchState = 'y';
      this.onChange.emit(true);
      return true;
  }

  onclickNo() {
      this.switchState = 'n';
      this.onChange.emit(false);
      return false;
  }

  onSetNeutral() {
      this.switchState = '';
      this.onChange.emit(null);
      return '';
  }
}
